export default __webpack_public_path__ + "static/media/broker-template-1.786caa90.svg";